<template>
  <div class="list_page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" label-width="70px">
        <!-- 调查标题 -->
        <el-form-item label="调查标题">
          <el-input
            v-model="queryParams.title"
            placeholder="请输入调查标题"
          ></el-input>
        </el-form-item>
        <!-- 创建人 -->
        <el-form-item label="创建人">
          <el-input
            v-model="queryParams.creator"
            placeholder="请输入创建人"
          ></el-input>
        </el-form-item>
        <!-- 调查时间 -->
        <el-form-item label="调查时间">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="queryParams.date"
            type="daterange"
            align="right"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>

        <!-- 状态 -->
        <el-form-item label="状态">
          <el-select v-model="queryParams.status" filterable clearable>
            <el-option
              v-for="(item, index) of options"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
            <!-- <el-option label="已发布" :value="1"></el-option> -->
          </el-select>
        </el-form-item>

        <!-- 操作 -->
      
          <el-button type="primary" @click="doSearch"
            >查询</el-button
          >
          <el-button type="primary" plain @click="handleResetQuery"
            >重置</el-button
          >
   
      </el-form>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <div class="table-btn">
        <!-- <el-button
          type="primary"
          size="mini"
          icon="el-icon-download"
          @click="handleExport"
          :loading="exportLoading"
          >导出</el-button
        > -->
        <el-button
          type="text"
          icon="el-icon-plus"
          @click="handleAdd"
          >新增</el-button
        >
        <el-button
          type="text"
          icon="el-icon-delete"
          @click="handleDel"
          :loading="delload"
          >删除</el-button
        >
        <el-button
         type="text"
          icon="el-icon-s-promotion"
          :loading="postload"
          @click="handlePost('发布')"
          >发布</el-button
        >
      </div>
      <!--    v-loading="tableLoading" -->
      <el-table
        ref="tableRef"
        highlight-current-row
        border
        stripe
        :data="tableData"
        fit
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40" disabled align="center">
        </el-table-column>
        <!-- 序号 -->
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{ getColumnIndex(scope.$index) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="调查标题"
          show-overflow-tooltip
          align="center"
          min-width="200"
        >
        </el-table-column>
        <el-table-column
          prop="url"
          label="调查地址"
          show-overflow-tooltip
          align="center"
          min-width="200"
        >
          <template slot-scope="scope">
            <a
              class="lineTheme"
              :href="decodeURIComponent(scope.row.url)"
              target="_blank"
              rel="noopener noreferrer"
              >{{ decodeURIComponent(scope.row.url) }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="creator"
          label="创建人"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          show-overflow-tooltip
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="people"
          label="状态"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0" size="mini">{{
              getval(scope.row.status)
            }}</el-tag>
            <el-tag type="success" v-if="scope.row.status == 1" size="mini">{{
              getval(scope.row.status)
            }}</el-tag>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column
          label="操作"
          align="center"
          width="160px"
          fixed="right"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button
              size="mini"
              type="text"
              @click="handleLook(scope.row, scope.$index)"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.status === 0"
              size="mini"
              type="text"
              @click="handleLook(scope.row, scope.$index, 1)"
              >编辑</el-button
            >
            <el-button
              v-if="scope.row.status === 1"
              size="mini"
              type="text"
              @click="handlePost(scope.row)"
              >撤回</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="page.total > 0">
        <pagination
          :total="page.total"
          :page.sync="page.pageNum"
          :limit.sync="page.pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import listCurd from "@/mixins/listCurd";
import { surveyLs, surveyPost, surveyDel } from "@/api/questionnaire";
import { getDict } from "@/api/api";
import md5 from "js-md5";
import { getDownloadFiles } from "@/util/downFile";

export default {
  components: {},
  mixins: [listCurd],
  data() {
    return {
      postload: false,
      delload: false,
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      // 查询参数
      queryParams: {
        title: "",
        date: [],
        creator: "",
        status: "",
      },
      // 表格数据
      listMethod: [],
      exportLoading: false,
      selectLs: [],
      options: [],
    };
  },
  created() {
    // 获取表格数据
    this.getList();
    this.getDict();
  },
  methods: {
    formatDate(isoStr, fmt = "yyyy-MM-dd HH:mm:ss") {
      const d = new Date(isoStr);
      const pad = (n) => n.toString().padStart(2, "0");
      const map = {
        yyyy: d.getFullYear(),
        MM: pad(d.getMonth() + 1),
        dd: pad(d.getDate()),
        HH: pad(d.getHours()),
        mm: pad(d.getMinutes()),
        ss: pad(d.getSeconds()),
      };
      return fmt.replace(/yyyy|MM|dd|HH|mm|ss/g, (m) => map[m]);
    },
    getval(code) {
      let obj = this.options.find((item) => item.code == code);
      return obj ? obj.value : "";
    },
    async getDict() {
      let res = await getDict({
        data: {
          codeParent: "surveyStatus",
        },
        page: {
          pageNum: 1,
          pageSize: 10,
        },
      });
      if (res.status == 0) {
        this.options = res.data.records;
      }
    },
    handlePaginationChange(val) {
      this.page.pageNum = val.page;
      this.page.pageSize = val.limit;
      this.getList();
    },
    handleSelectionChange(val) {
      this.selectLs = val;
    },
    async getList() {
      // this.tableLoading = true;
      let obj = {
        data: {
          title: this.queryParams.title,
          url: this.queryParams.url,
          creator: this.queryParams.creator,
          status: this.queryParams.status,
          startTime: this.queryParams.date ? this.queryParams.date[0] : '',
          endTime: this.queryParams.date ? this.queryParams.date[1] : '',
        },
        page: this.page,
      };
      const res = await surveyLs(obj);
      // this.tableLoading = false;
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.page.total = res.data.count;
      }
    },
    handleAdd() {
      this.$router.push({
        path: "/questionnaireDetail",
        query: { atype: "add" },
      });
    },
    handleDel() {
      let obj = {
        page: {
          pageNum: 1,
          pageSize: 10,
        },
        data: null,
      };
      if (this.selectLs.length == 0) {
        this.$DonMessage.error("请选择要删除的项");
        return;
      }

      let arr = [];
      for (let a = 0; a < this.selectLs.length; a++) {
        let item = this.selectLs[a];
        arr.push(item.id);
      }
      obj.dataList = arr;
      obj.data = obj.dataList[0];
      this.$confirm("确认删除表格选中项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.delload = true;
          let res = await surveyDel(obj);
          this.delload = false;
          if (res.status == "0") {
            this.$DonMessage.success("删除成功!");
            this.getList();
          }
        })
        .catch(() => {});
    },
    handlePost(val) {
      console.log("🚀 ~ handlePost ~ val:", val);
      let obj = {
        page: {
          pageNum: 1,
          pageSize: 10,
        },
      };
      if (val.id) {
        obj.dataList = [
          {
            surveyId: val.id,
            status: 0,
          },
        ];
      } else {
        if (this.selectLs.length == 0) {
          this.$DonMessage.warning("请选择要发布的项");
          return;
        }
        let arr = [];
        for (let a = 0; a < this.selectLs.length; a++) {
          let item = this.selectLs[a];
          arr.push({
            surveyId: item.id,
            status: 1,
          });
        }
        obj.dataList = arr;
      }
      this.$confirm(
        val != "发布"
          ? "确认撤回该项, 是否继续?"
          : "确认发布表格选中项, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          if (!val) {
            this.postload = true;
          }
          const res = await surveyPost(obj);
          if (!val) {
            this.postload = false;
          }
          if (res.status == 0) {
            this.$DonMessage.success("操作成功!")
            this.getList();
          }
        })
        .catch(() => {});
    },
    // 查看
    async handleLook(data = {}, index, num) {
      let obj = {
        rowid: data.id,
        atype: md5(String(data.id) + "123"),
      };
      if (num == 1) {
        obj.atype = md5(String(data.id));
      }
      this.$router.push({
        path: "/questionnaireDetail",
        query: obj,
      });
    },
    // 导出
    async handleExport() {
      this.exportLoading = true;
      let obj = {
        data: {
          title: this.queryParams.title,
          url: this.queryParams.url,
          creator: this.queryParams.creator,
          status: this.queryParams.status,
          startTime: this.queryParams.date[0],
          endTime: this.queryParams.date[1],
        },
        page: this.page,
      };
      // const res = await surveyLs(obj);
      // getDownloadFiles(res);
      // if (res.fileName) {
      //   this.$DonMessage.success("导出成功！");
      // }
      // this.exportLoading = false;
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
